
import enTranslations from './en';
import huTranslations from './hu';

export const translations = {
  en: enTranslations,
  hu: huTranslations
};

export type TranslationKey = keyof typeof enTranslations;
